import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function RelatedReading({ productId }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/products/${productId}/related-posts`).then(r => setPosts(r.data)).catch(() => setPosts([]));
  }, [productId]);

  if (posts.length === 0) return null;

  return (
    <div className="border-b border-zinc-900 px-6 md:px-12 py-10" data-testid="related-reading">
      <div className="tag mb-3">From The Blog</div>
      <h2 className="text-2xl font-black tracking-tighter uppercase font-[Outfit] mb-6">Related Reading</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-900 border border-zinc-900">
        {posts.map(post => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="group bg-white flex gap-4 p-5 hover:bg-zinc-50" data-testid={`related-post-${post.slug}`}>
            <div className="w-20 h-20 bg-zinc-100 border border-zinc-900 flex-shrink-0 overflow-hidden">
              {post.cover_image && <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />}
            </div>
            <div className="min-w-0">
              <div className="font-black font-[Outfit] uppercase tracking-tight leading-tight text-sm group-hover:text-[#ff3333] line-clamp-2">{post.title}</div>
              <p className="text-xs text-zinc-600 mt-1 line-clamp-2">{post.excerpt}</p>
              <div className="mt-2 text-[0.65rem] uppercase tracking-widest font-bold font-[Outfit] flex items-center gap-1">
                Read <ArrowRight size={11} weight="bold" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
